export default __webpack_public_path__ + "static/media/bell.febe35da.svg";